import moment from 'moment';
import { createSelector } from 'reselect';
import * as types from '../actions/action-types';

const INITIAL_STATE = {
    events: [],
    eventWindowStart: null,
    eventWindowEnd: null,
    filters: [
        'creation',
        'review',
        'aaIncomplete',
        'aaReview',
        'default',
        'aaPending'
    ],
    regionFilter: '',
    districtFilter: '',
    rSFilter: '',
    rSSFilter: '',
    rSSFilterType: '',
    isFromEacFilter: false,
    isFromPrFilter: false,
    eventStatusFilter: [],
    eventReportStatusFilter: [],
    focus: new Date().toString(),
    view: 'month',
    calendar: true,
    calendarFiltersActive: false,
    calLoading: false,
    calendarRssOssCodeList: [],
    calendarDistrictCodeList: [],
    calendarRegionCodeList: [
        {
            name: 'Western',
            code: 'west'
        },
        {
            name: 'Eastern',
            code: 'east'
        }
    ],
    calendarRecruitingStationCodeList: []
};

const inc = (mom, direction, increment) =>
    (direction === 'next'
        ? mom.add(1, increment)
        : mom.subtract(1, increment)
    ).toISOString();
const incFocus = (currentFocus, direction, increment) => {
    const mom = moment(currentFocus).clone();
    let incFocus = currentFocus;
    if (increment === 'month' || increment === 'week' || increment === 'day') {
        incFocus = inc(mom, direction, increment);
    }

    return incFocus;
};

//Calendar
export const getCanShowCalendar = state => state.viewportWidth >= 768;
export const getCalendarState = state => state.calendar;
export const getViewType = state => state.view;
export const getFocusDate = state => state.focus;
export const getEvents = state => state.events;
export const getFilters = state => state.filters;
export const getRegionFilter = state => state.regionFilter;
export const getDistrictFilter = state => state.districtFilter;
export const getRSFilter = state => state.rSFilter;
export const getRSSFilter = state => state.rSSFilter;
export const getIsFromEacFilter = state => state.isFromEacFilter;
export const getIsFromPrFilter = state => state.isFromPrFilter;
export const getEventStatusFilter = state => state.eventStatusFilter;
export const getEventReportStatusFilter = state =>
    state.eventReportStatusFilter;
export const getCalLoading = state => state.calLoading;

export const getCalendarRegionCodeList = state => state.calendarRegionCodeList;
export const getCalendarDistrictCodeList = state =>
    state.calendarDistrictCodeList;
export const getCalendarRecruitingStationCodeList = state =>
    state.calendarRecruitingStationCodeList;
export const getCalendarRssOssCodeList = state => state.calendarRssOssCodeList;

export const getShowCalendarToggle = createSelector(
    [getViewType, getCanShowCalendar],
    (view, canShow) => view === 'month' && canShow
);
export const getShowCalendar = createSelector(
    [getViewType, getCalendarState, getCanShowCalendar],
    (view, calendar, canShow) => view === 'month' && calendar && canShow
);

const testDay = {
    day: ({ start, end }, date) =>
        moment(date).isBetween(
            moment(start).add(-1, 'day'),
            moment(end).add(1, 'day')
        ),
    week: ({ start, end }, date) => {
        return (
            moment(start).isBetween(
                moment(date).startOf('week'),
                moment(date).endOf('week')
            ) ||
            moment(end).isBetween(
                moment(date).startOf('week'),
                moment(date).endOf('week')
            ) ||
            (moment(start) <= moment(date).startOf('week') &&
                moment(end) >= moment(date).endOf('week'))
        );
    },
    month: ({ start, end }, date) =>
        moment(start).isBetween(
            moment(date).startOf('month'),
            moment(date).endOf('month')
        ) ||
        moment(end).isBetween(
            moment(date).startOf('month'),
            moment(date).endOf('month')
        )
};

export const getActiveEvents = createSelector(
    [
        getEvents,
        getFilters,
        getViewType,
        getFocusDate,
        getShowCalendar,
        getRegionFilter,
        getDistrictFilter,
        getRSFilter,
        getRSSFilter,
        getIsFromEacFilter,
        getIsFromPrFilter,
        getEventStatusFilter,
        getEventReportStatusFilter
    ],
    (
        events,
        filters,
        view,
        focus,
        calendar,
        regionFilter,
        districtFilter,
        rSFilter,
        rSSFilter,
        isFromEacFilter,
        isFromPrFilter,
        eventStatusFilter,
        eventReportStatusFilter
    ) =>
        events
            .filter(event =>
                filters.includes(event.className.replace('status-', ''))
            )
            .filter(event => (calendar ? true : testDay[view](event, focus)))
            .filter(
                event =>
                    regionFilter && regionFilter !== ''
                        ? event.region === regionFilter
                        : true
            )
            .filter(event => {
                console.log(districtFilter);
                console.log(event.district);
                return districtFilter && districtFilter !== ''
                    ? event.district === districtFilter
                    : true;
            })
            .filter(
                event =>
                    rSFilter && rSFilter !== ''
                        ? event.recruitingStationCode === rSFilter
                        : true
            )
            .filter(event => {
                return rSSFilter && rSSFilter !== 'null' && rSSFilter !== ''
                    ? `${event.rssOssCode}-${event.rssOssType}` ===
                          rSSFilter.toString()
                    : true;
            })
            .filter(event => (isFromEacFilter ? event.isFromEac : true))
            .filter(event => (isFromPrFilter ? event.isFromPr : true))
            .filter(event => {
                //Event Status
                //Event Report Status
                let isMatch = false;
                if (
                    eventStatusFilter.length === 0 &&
                    eventReportStatusFilter.length === 0
                ) {
                    isMatch = true;
                }

                //Event Status
                if (eventStatusFilter.length !== 0) {
                    if (
                        event.status === 'Incomplete' &&
                        eventStatusFilter.includes('Event Creation')
                    ) {
                        isMatch = true;
                    }
                    if (
                        event.status === 'Unapproved' &&
                        eventStatusFilter.includes('Event Review')
                    ) {
                        isMatch = true;
                    }
                }

                //Event Report Status
                if (eventReportStatusFilter.length !== 0) {
                    if (event.status === 'Approved') {
                        if (
                            event.eventReportStatus === 'Pending' &&
                            eventReportStatusFilter.includes(
                                'After Action Pending'
                            )
                        ) {
                            isMatch = true;
                        }

                        if (event.eventReportStatus === 'Incomplete') {
                            if (
                                moment(event.startDate) > moment() &&
                                eventReportStatusFilter.includes(
                                    'After Action Pending'
                                )
                            ) {
                                isMatch = true;
                            } else {
                                if (
                                    eventReportStatusFilter.includes(
                                        'After Action Incomplete'
                                    )
                                ) {
                                    isMatch = true;
                                }
                            }
                        }
                        if (
                            event.eventReportStatus === 'Unapproved' &&
                            eventReportStatusFilter.includes(
                                'After Action Review'
                            )
                        ) {
                            isMatch = true;
                        }
                        if (
                            event.eventReportStatus === 'Approved' &&
                            eventReportStatusFilter.includes(
                                'Event/After Action Closed'
                            )
                        ) {
                            isMatch = true;
                        }
                    }
                }

                return isMatch;
            })
);

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.SET_CALENDAR_VIEW) {
        return {
            ...state,
            view: action.view
        };
    } else if (action.type === types.SET_CALENDAR_ACTIVE) {
        return {
            ...state,
            calendar: action.active
        };
    } else if (action.type === types.TOGGLE_FILTER) {
        return {
            ...state,
            filters: state.filters.includes(action.value)
                ? state.filters.filter(val => val !== action.value)
                : [...state.filters, action.value]
        };
    } else if (action.type === types.SET_FOCUS_DATE) {
        return {
            ...state,
            focus: incFocus(state.focus, action.direction, action.increment)
        };
    } else if (action.type === types.SET_FOCUS_DATE_DIRECT) {
        return {
            ...state,
            focus: action.payload
        };
    } else if (action.type === types.RESIZE) {
        return {
            ...state,
            viewportWidth: action.width
        };
    } else if (action.type === types.FETCH_CALENDAR_SUCCESS) {
        const events = action.newData
            ? action.payload
            : [...state.events, ...action.payload];
        return {
            ...state,
            // events: [...state.events, ...action.payload]
            events: events,
            calendarFiltersActive: false
        };
    } else if (action.type === types.SET_EVENT_WINDOW_START) {
        return {
            ...state,
            eventWindowStart: action.value
        };
    } else if (action.type === types.SET_EVENT_WINDOW_END) {
        return {
            ...state,
            eventWindowEnd: action.value
        };
    } else if (action.type === types.TOGGLE_CALENDAR_FILTERS) {
        return {
            ...state,
            calendarFiltersActive: !state.calendarFiltersActive
        };
    } else if (action.type === types.APPLY_CALENDAR_FILTERS) {
        return {
            ...state,
            regionFilter:
                action.filters.regionCode &&
                !Array.isArray(action.filters.regionCode)
                    ? action.filters.regionCode
                    : '',
            districtFilter:
                action.filters.districtCode &&
                !Array.isArray(action.filters.districtCode)
                    ? action.filters.districtCode
                    : '',
            rSFilter:
                action.filters.recruitingStationCode &&
                !Array.isArray(action.filters.recruitingStationCode)
                    ? action.filters.recruitingStationCode
                    : '',
            rSSFilter:
                action.filters.rssOssCode &&
                !Array.isArray(action.filters.rssOssCode)
                    ? action.filters.rssOssCode
                    : '',
            rSSFilterType:
                action.filters.rssOssCode &&
                !Array.isArray(action.filters.rssOssCode)
                    ? action.filters.rssOssCode.split('-')[1]
                    : '',
            isFromEacFilter:
                Array.isArray(action.filters.isFromEac) &&
                action.filters.isFromEac.length > 0,
            isFromPrFilter:
                Array.isArray(action.filters.isFromPr) &&
                action.filters.isFromPr.length > 0,
            eventStatusFilter: action.filters.eventStatus
                ? action.filters.eventStatus
                : [],
            eventReportStatusFilter: action.filters.eventReportStatus
                ? action.filters.eventReportStatus
                : [],
            calendarFiltersActive: !state.calendarFiltersActive
        };
    } else if (action.type === types.RESET_CAL_EVENTS) {
        return {
            ...state,
            events: [],
            eventWindowStart: null,
            eventWindowEnd: null,
            isFromEacFilter: false,
            isFromPrFilter: false,
            eventStatusFilter: [],
            eventReportStatusFilter: [],
            focus: new Date().toString(),
            calendar: true,
            calendarFiltersActive: false
        };
    } else if (action.type === types.CAL_LOADING) {
        return {
            ...state,
            calLoading: true
        };
    } else if (action.type === types.CAL_LOADING_SUCCESS) {
        return {
            ...state,
            calLoading: false
        };
    } else if (action.type === types.UPDATE_CALENDAR_DISTRICT_SUCCESS) {
        return { ...state, calendarDistrictCodeList: action.payload };
    } else if (action.type === types.UPDATE_CALENDAR_RS_SUCCESS) {
        return { ...state, calendarRecruitingStationCodeList: action.payload };
    } else if (action.type === types.UPDATE_CALENDAR_RSS_OSS_SUCCESS) {
        return { ...state, calendarRssOssCodeList: action.payload };
    } else if (action.type === types.ONLOAD_CALENDAR_LOCATIONS) {
        return {
            ...state,
            regionFilter: action.regionFilter,
            districtFilter: action.districtFilter,
            rSFilter: action.rSFilter,
            rSSFilter: action.rSSFilter,
            rSSFilterType: action.rSSFilterType
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/calendar.js